<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'dossier-create'}">Dossier erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Dossiers</h1>
            <table class="table table-striped" v-if="dossiers">
                <thead>
                <tr>
                    <th>Titel</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="dossier in dossiers">
                    <td>{{dossier.name.text}}</td>
                    <td class="text-right">
                        <a href="#" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, dossier),
                            message: 'Bist du sicher, dass du das Dossier <strong>'+dossier.name.text+'</strong> löschen möchtest?'}"><i
                                class="fa fa-trash"></i></a>
                        <router-link :to="{ name: 'dossier-edit', params: { dossierId: dossier.id }}"><i
                                class="fa fa-edit fa-fw"></i></router-link>
                    </td>
                </tr>
                </tbody>
            </table>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    dossiers() {
      return axios
        .get("/api/" + store.state.language + "/dossier/list")
        .then(({ data }) => data.result.sort((a, b) => a.position - b.position));
    }
  },
  methods: {
    remove(dialog, dossier) {
      this.dossiers.splice(this.dossiers.indexOf(dossier), 1);
      axios.post(
        "/api/" + store.state.language + "/dossier/" + dossier.id + "/delete"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/dossier/List.vue